import type { JSX } from 'react';
import { useQueryUrlSync } from '@/hooks/useQueryUrlSync';
import { Spinner } from '@/components/Spinner';

interface QueryUrlSyncGuardProps {
    children: JSX.Element;
}

export function QueryUrlSyncGuard({
    children,
}: QueryUrlSyncGuardProps): JSX.Element {
    const { isInitialized } = useQueryUrlSync();

    if (!isInitialized) {
        return (
            <div className="h-full flex items-center justify-center">
                <Spinner />
            </div>
        );
    }

    return children;
}
